import { render, staticRenderFns } from "./InvestorFunnelItem.vue?vue&type=template&id=680f9810&scoped=true&"
import script from "./InvestorFunnelItem.vue?vue&type=script&lang=js&"
export * from "./InvestorFunnelItem.vue?vue&type=script&lang=js&"
import style0 from "./InvestorFunnelItem.vue?vue&type=style&index=0&id=680f9810&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f9810",
  null
  
)

export default component.exports